<template>
  <div></div>
</template>

<script>
  export default {
    created() {
      let path = {
        path: `/dashboard`,
        name: 'dashboard',
        meta: { keepAlive: true },
      };
      this.$store.dispatch('menu/setIndexType', 'dsly');
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
  };
</script>

<style lang="scss" scoped></style>
